import { Calendar, ArrowLeft } from 'lucide-react';
import { Button } from '@paulownia/shared/components/ui/button';

interface MerchantAbsentProps {
  tenantName: string;
  absenceEnd?: string;
  onBackClick: () => void;
}

export function MerchantAbsent({ tenantName, absenceEnd, onBackClick }: MerchantAbsentProps) {
  const formattedEnd = absenceEnd
    ? new Date(absenceEnd + 'T12:00:00').toLocaleDateString('fr-FR', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      })
    : null;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="bg-orange-600 text-white p-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={onBackClick}
          className="text-white hover:bg-orange-700"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Retour
        </Button>
      </div>

      <div className="flex-1 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full text-center">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Calendar className="h-8 w-8 text-orange-600" />
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            {tenantName}
          </h1>

          <p className="text-lg text-gray-600 mb-4">
            Ce commerçant est actuellement absent
          </p>

          {formattedEnd && (
            <p className="text-sm text-gray-500 mb-6">
              De retour le {formattedEnd}
            </p>
          )}

          <Button onClick={onBackClick} className="w-full">
            Retour à l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
}
